import { parseOwnerValue } from "./owners";
import { parsePositionValue } from "./positions";
import {
  IAssignOrganizationValue,
  IAssignPositionValue,
  ILicenseAssignFormValues,
  ILicenseAssignOrganizationPayload,
  ILicenseAssignPayload,
  ILicenseAssignPositionPayload,
  ILicenseRevokeFormValues,
  ILicenseRevokePayload,
} from "./types";

export const isAssignPositionFilled = (position: IAssignPositionValue) =>
  Boolean(position?.position);

export const isAssignOrganizationFilled = (
  organization: IAssignOrganizationValue,
) =>
  Boolean(organization?.organization) &&
  (organization?.positions ?? []).some(isAssignPositionFilled);

export const isAssignFormFilled = (values: ILicenseAssignFormValues) =>
  (values.organizations ?? []).some(isAssignOrganizationFilled);

export const isRevokeOrganizationFilled = (
  organization: IAssignOrganizationValue,
) => Boolean(organization?.organization);

export const isRevokeFormFilled = (values: ILicenseRevokeFormValues) =>
  (values.organizations ?? []).some(isRevokeOrganizationFilled);

export const mapAssignFormToPayload = (
  values: ILicenseAssignFormValues,
): ILicenseAssignPayload => ({
  organizations: (values.organizations ?? []).reduce<
    ILicenseAssignOrganizationPayload[]
  >((accOrganizations, organization) => {
    if (!organization?.organization) {
      return accOrganizations;
    }

    if (!isAssignOrganizationFilled(organization)) {
      return accOrganizations;
    }

    accOrganizations.push({
      owner: parseOwnerValue(organization.organization.value),
      positions: (organization.positions ?? []).reduce<
        ILicenseAssignPositionPayload[]
      >((accPositions, position) => {
        if (!position?.position || !isAssignPositionFilled(position)) {
          return accPositions;
        }

        const employeeIds = (position.employees ?? []).reduce<number[]>(
          (accIds, employee) => {
            if (employee?.employee) {
              accIds.push(Number(employee.employee.value));
            }
            return accIds;
          },
          [],
        );

        accPositions.push({
          ...parsePositionValue(position.position.value),
          allEmployees: employeeIds.length === 0,
          employeeIds,
        });

        return accPositions;
      }, []),
    });
    return accOrganizations;
  }, []),
});

export const mapRevokeFormToPayload = (
  values: ILicenseRevokeFormValues,
): ILicenseRevokePayload => ({
  organizations: (values.organizations ?? []).reduce<
    ILicenseAssignOrganizationPayload[]
  >((accOrganizations, organization) => {
    if (!organization?.organization) {
      return accOrganizations;
    }

    accOrganizations.push({
      owner: parseOwnerValue(organization.organization.value),
      positions: (organization.positions ?? []).reduce<
        ILicenseAssignPositionPayload[]
      >((accPositions, position) => {
        if (!position?.position) {
          return accPositions;
        }

        const employeeIds = (position.employees ?? []).reduce<number[]>(
          (accIds, employee) => {
            if (employee?.employee) {
              accIds.push(Number(employee.employee.value));
            }
            return accIds;
          },
          [],
        );

        accPositions.push({
          ...parsePositionValue(position.position.value),
          allEmployees: employeeIds.length === 0,
          employeeIds,
        });

        return accPositions;
      }, []),
    });

    return accOrganizations;
  }, []),
});
